// For sending messages to the smartglass

import { watch } from 'vue';
import { VUZIX_EVENTS } from '@/Utils/vice-constants';
import useSessionStore from '@/Stores/useSessionStore';
import useIOTDevicesStore from '@/Stores/useIOTDevicesStore';

const sessionStore = useSessionStore();
const streamingDeviceStore = useIOTDevicesStore();

function useSendDeviceMessage() {
  const turnOffSmartGlass = async () => {
    console.log(`emitting "${VUZIX_EVENTS.DISCONNECT}"`);

    streamingDeviceStore.devices.smartglasses.disconnecting = true;
    setTimeout(() => {
      streamingDeviceStore.devices.smartglasses.disconnecting = false;
    }, 2000);

    await streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.DISCONNECT);
    streamingDeviceStore.devices.smartglasses.connected = false;
  };

  const toggleSmartglassAudioIO = (shouldMute) => {
    console.log(`emitting "${VUZIX_EVENTS.SET_SPEAKER_STATE}", shouldMute: ${shouldMute}`);

    streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.SET_SPEAKER_STATE, {
      isMuted: shouldMute,
    });
    console.log(`emitting "${VUZIX_EVENTS.SET_MICROPHONE_STATE}", shouldMute: ${shouldMute}`);

    streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.SET_MICROPHONE_STATE, {
      isMuted: shouldMute,
    });
  };

  const pauseSession = () => {
    console.log(`emitting "${VUZIX_EVENTS.SET_SESSION_STATE}", isRunning: ${false}`);
    streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.SET_SESSION_STATE, {
      isRunning: false,
    });
    // setTimeout(() => {
    //   toggleSmartglassAudioIO(true);
    // }, 1000);
  };

  const resumeSession = () => {
    console.log(`emitting "${VUZIX_EVENTS.SET_SESSION_STATE}", isRunning: ${true}`);
    streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.SET_SESSION_STATE, {
      isRunning: true,
    });
    // setTimeout(() => {
    //   toggleSmartglassAudioIO(false);
    // }, 1000);
  };

  // send a text message to the smartglass
  const sendSmartGlassTextMessage = ({ content, senderInfo }) => {
    console.log(`emitting "${VUZIX_EVENTS.MESSAGE}, content: ${content}`);

    streamingDeviceStore.iotSockets.smartglasses?.emit(VUZIX_EVENTS.MESSAGE, {
      message: content,
      sender: senderInfo.name,
    });
  };

  watch(
    () => sessionStore.isPhasePaused,
    (isPaused) => {
      if (!sessionStore.isClinician) return;
      if (isPaused) {
        pauseSession();
      } else {
        resumeSession();
      }
    },
  );

  return {
    pauseSession,
    resumeSession,
    turnOffSmartGlass,
    toggleSmartglassAudioIO,
    sendSmartGlassTextMessage,
  };
}

export default useSendDeviceMessage;
